import React from 'react'
import moment from 'moment'
import Avatar from 'components/Avatar'
import CustomTag from 'components/CustomTag'
import AwardsIcon from 'components/icons/AwardsIcon'
import { COLORS } from 'theme'

import {
  GreyText,
  MainHeading,
  SecondaryHeading,
  SecondGreyText,
  StyledP,
  SubFLex,
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import DividerIcon from 'components/icons/DividerIcon'
import WorkIcon from 'components/icons/WorkIcon'
import { FlexWrap } from 'components/UIComponents/FormStyles'
import { SubtitleSmall } from 'components/UIComponents/PreviewScreen/style'
import { TextContainer } from 'modules/JobPreview/style'

// Resume dates are stored in the system format 'MM/YYYY'. Parsing them without
// that token makes moment fall back to `new Date('01/2025')`, which renders
// "Invalid date" — guard the format and any unparseable/blank value.
const formatMonthYear = (value) => {
  if (!value) {
    return ''
  }
  const parsed = moment(value, 'MM/YYYY')
  return parsed.isValid() ? parsed.format('MMM YYYY') : ''
}

const WorkExperienceSection = ({ experience, resume }) => {
  return (
    <>
      <MainHeading>Work Experience</MainHeading>
      {experience && experience.map((item, index) => (
        <SubFLex column gap="25px" key={index + 'workExperience'}>
          <SubFLex gap="12px">
            <div>
              <Avatar
                background="none"
                src={''}
                size={48}
                icon={resume ? <WorkIcon /> : <AwardsIcon />}
                boxShadow={true}
                padding="5px"
                shape={resume ? '' : 'square'}
              />
            </div>
            <SubFLex column gap="10px">
              <SubFLex gap="20px" flexStart>
                <SecondaryHeading fontWeight="600">
                  {item?.role}
                </SecondaryHeading>
                <CustomTag
                  message="Full Time"
                  bordered={true}
                  colorType="grey"
                  border={COLORS.GREY_T_80}
                />
              </SubFLex>
              {resume ? (
                <>
                  <GreyText color={COLORS.GREY_T_60}>
                    {formatMonthYear(item?.started_in)}
                    {' - '}
                    {formatMonthYear(item?.ended_in) || 'Present'}
                  </GreyText>
                  {(item?.companyName || item?.organization) && (
                    <SecondGreyText>{item?.companyName || item?.organization}</SecondGreyText>
                  )}
                  {item?.skill_set?.length > 0 && (
                    <SubFLex
                      centerVertically
                      gap="5px"
                      marginBottom="5px"
                      flexWrap="wrap"
                    >
                      <SecondGreyText marginBottom="0" paddingTop="6px">
                        Skills - &nbsp;
                      </SecondGreyText>
                      {item?.skill_set?.map((item, index) => (
                        <CustomTag
                          key={index + item?.name}
                          message={item?.name}
                          bordered={true}
                          border={COLORS.GREY_T_80}
                        />
                      ))}
                    </SubFLex>
                  )}
                </>
              ) : (
                <>
                  <SecondGreyText>{item?.organization}</SecondGreyText>
                  <GreyText color={COLORS.GREY_T_60}>
                    {formatMonthYear(item?.started_in)}
                    {' - '}
                    {formatMonthYear(item?.ended_in) || 'Present'}
                  </GreyText>
                  {item?.skill_set?.length > 0 && (
                    <SubFLex>
                      <SecondGreyText marginBottom="0" paddingTop="6px">
                        Skills - &nbsp;
                      </SecondGreyText>
                      {item?.skill_set?.map((item, index) => (
                        <CustomTag
                          key={index + item?.name}
                          message={item?.name}
                          bordered={true}
                          border={COLORS.GREY_T_80}
                        />
                      ))}
                    </SubFLex>
                  )}
                </>
              )}

              {resume && (
                <FlexWrap gap="10px">
                  <TextContainer>
                    {item?.function && (
                      <>
                        <SubFLex column>
                          <SecondGreyText>Function</SecondGreyText>
                          <SecondaryHeading>{item?.function}</SecondaryHeading>
                        </SubFLex>
                        <SubtitleSmall>
                          <DividerIcon />
                        </SubtitleSmall>
                      </>
                    )}
                  </TextContainer>
                  {/* <TextContainer>
                    {item?.role && (
                      <>
                        <SubFLex column>
                          <SecondGreyText>Role</SecondGreyText>
                          <SecondaryHeading>{item?.role}</SecondaryHeading>
                        </SubFLex>
                        <SubtitleSmall>
                          <DividerIcon />
                        </SubtitleSmall>
                      </>
                    )}
                  </TextContainer> */}
                  <TextContainer>
                    {item?.industry && (
                      <SubFLex column>
                        <SecondGreyText>Industry</SecondGreyText>
                        <SecondaryHeading>{item?.industry}</SecondaryHeading>
                      </SubFLex>
                    )}
                  </TextContainer>
                </FlexWrap>
              )}
              {item?.description && (
                <StyledP
                  dangerouslySetInnerHTML={{
                    __html: item?.description,
                  }}
                />
              )}
            </SubFLex>
          </SubFLex>
        </SubFLex>
      ))}
    </>
  )
}

export default WorkExperienceSection
